import React, { ReactNode } from 'react';
import styles from './Sector.module.scss';

interface SectorProps {
    hue: number;
    prize: ReactNode;
    angle: number;
    isWinner: boolean;
}

export const Sector = ({ hue, prize, angle, isWinner }: SectorProps) => {
    return (
        <div 
            className={`${styles.sector} ${isWinner ? styles.winningSector : ''}`}
            style={{
                '--hue': hue,
                transform: `rotate(${angle}deg)`
            } as React.CSSProperties}
        >
            <div className={styles.sectorContent}>
                <div className={styles.prizeImage}>
                    { prize }
                </div>
                <span className={styles.prizeLabel}>.</span>
            </div>
        </div>
    );
};
